import { gql } from '@apollo/client';
import { INVOICE_ORDER_FIELDS } from '../Invoice/graphql';
import { CLIENT_FIELDS } from '@/graphql/queries/clients';
import { ORDER_FIELDS } from '@/graphql/queries/orders';
import { ITEM_FIELDS } from '@/graphql/queries/items';
import { SERVICES_FIELDS } from '@/graphql/fragments/services';

export const GET_SHIPPERS = gql`
    ${CLIENT_FIELDS}
    query GetShippers($where: orders_bool_exp!) {
        results: orders(distinct_on: [shipper_id], where: $where) {
            order_id
            shipper_id
            order_shipper {
                ...ClientFields
            }
        }
    }
`;

export const GET_CARRIERS = gql`
    ${CLIENT_FIELDS}
    query GetCarriers($where: orders_bool_exp!) {
        results: orders(distinct_on: [carrier_id], where: $where) {
            order_id
            carrier_id
            order_carrier {
                ...ClientFields
            }
        }
    }
`;

export const COMPLETED_ORDERS = gql`
    ${INVOICE_ORDER_FIELDS}
    query CompletedOrders($where: orders_bool_exp!, $limit: Int!, $offset: Int!, $order_by: [orders_order_by!]!) {
        results: orders(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
            ...InvoiceOrderFields
            routes {
                mapping_id
                order_id
                route_id
                type
                created_at
                route {
                    route_id
                    route_alias
                    route_number
                    resource {
                        resource_id
                        name
                    }
                }
            }
            shipper_invoice {
                carrier_invoice_id
                invoice_number
                status
            }
        }
    }
`;

export const UPDATE_ORDERS = gql`
    ${INVOICE_ORDER_FIELDS}
    mutation UpdateOrders($order_ids: [uuid!]!, $patch: orders_set_input!) {
        updated: update_orders(where: { order_id: { _in: $order_ids } }, _set: $patch) {
            affected_rows
            returning {
                ...InvoiceOrderFields
            }
        }
    }
`;

export const GET_FULL_ORDER = gql`
    ${ORDER_FIELDS}
    ${ITEM_FIELDS}
    ${CLIENT_FIELDS}
    ${SERVICES_FIELDS}
    query GetFullOrder($order_id: uuid!) {
        result: orders_by_pk(order_id: $order_id) {
            ...OrderFields
            services {
                ...ServicesFields
            }
            order_shipper {
                ...ClientFields
            }
            itemsByOrderId {
                ...ItemFields
            }
        }
    }
`;